import React, { useEffect, useState } from "react";
import SearchBar from "../../../utils/searchbar";
import GlobalButton from "../../../utils/GlobalButton";
import Cards from "./Card";
import TabBtn from "./TabBtn";
import CreateBotModal from "./CreateButtonModal";
import dashboard from "../../../css/dashboard.module.css";
import CommonPagination from "../../../utils/Pagination";
import SortMenu from "../Analytics/SortMenu";
import Alerts from "../../shared/Alerts";
import { BotName } from "../../shared/AlertMessages";
import {useSearchParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import { deleteBot, deleteBots, get_bots, republishbots, startBots, stopBots } from "../../shared/ApiEndpoint";
import { BOTSLIMIT } from "../../shared/Constant";
import { updateURLFilters } from "../../../utils/updateURLFilters";
import PublishModal from "./PublishModal";
import { Modal, notification } from "antd";
import RepublishCard from "./RepublishCard";

const Dashboard = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  const initialValue = searchParam.get("bots_type") || "all";
  const initialKeyword = searchParam.get("keyword") || "";
  const initialPage = searchParam.get("page") || 1;
  const initial_SortBy = searchParam.get("sort_by") || "sort_by";
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPublicModal, setShowPublicModal] = useState(false);
  const [userDetails, setUserDetails] = useState([
    {
      id: 0,
      bot_name: "",
      bot_desc: "",
      modifiedDate: "",
      createdDate: "",
      bot_idlive:"",
      livebotStatus:""
    },
  ]);
  const [publishModalDetails, setPublishModalDetails] = useState({
    bot_id: 0,
    bot_name: "",
    bot_desc: "",
  });
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState(initialKeyword);
  const [selectedSort, setnewSelectedSort] = useState(initial_SortBy);
  const sortOptions = [
    { label: "Name (A-Z)", value: 1 },
    { label: "Name (Z-A)", value: 2 },
    { label: "DateAsc", value: 3 },
    { label: "DateDesc", value: 4 },
  ];
  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [id, SetselectedId] = useState(null);
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    fetch_bots(searchTerm, currentPage, selectedSort, value);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabbtnChange = (event, newValue) => {
    setValue(newValue);

    const params = new URLSearchParams();
  if (newValue && newValue !== "all") {
    params.set("bots_type", newValue);
  }

  // Update the URL
  setSearchParam(params);

  // Call updateURLFilters with only the new bots_type
  updateURLFilters(new URLSearchParams(), setSearchParam, {
    bots_type: newValue !== "all" ? newValue : null
  });

  // Fetch data with the new bots_type only
  fetch_bots("", 1, null, newValue);
  setSearchTerm("");
  setnewSelectedSort("sort_by");
  };
  const handleDelete = (id) => {
    setShowConfirmModal(true);
    SetselectedId(id);
  };

  const handleDeleteBot = async (id) => {
    const resp = await axiosInstance.put(
      deleteBot,
      {},
      {
        params: { bot_id: id },
        withCredentials: true,
      }
    );

    if (resp.status === 200) {
      fetch_bots(searchTerm, currentPage, selectedSort, value);
    }
  };

  const handlePublish = (botId, name, title) => {
    setPublishModalDetails({ bot_id: botId, bot_name: name, bot_desc: title });
    setShowPublicModal(true);
  };

  const fetch_bots = async (
    searchTerm = "",
    currentPage = 1,
    sort_by = "sort_by",
    value = "all"
  ) => {
    try {
      const payload = {
        limit: BOTSLIMIT,
        page_number: currentPage,
        ...(searchTerm && { search: searchTerm }),
        ...(typeof sort_by === "number" && { sort_by: sort_by }),
        ...(value && value !== "all" && { bots_type: value }),
      };
      const res = await axiosInstance.post(get_bots, payload, {
        withCredentials: true,
      });
      if (res.status === 200) {
        const data = res.data.result;
        const count = res.data.total;
        const progress = data.map((item) => ({
          id: item.id,
          bot_name: item?.bot_name,
          bot_desc: item?.bot_desc,
          modifiedDate: item?.modified_at,
          createdDate: item?.created_at,
          bot_idlive:item?.bot_id||"",
          livebotStatus:item?.status
        }));

        setUserDetails(progress);
        setTotalCount(count);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleOnSearch = (string, results) => {
    setSearchTerm(string);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (searchTerm.trim() !== "") {
        fetch_bots(searchTerm, currentPage, selectedSort, value);
      }
      if (searchTerm.trim() === "") {
        // setApprovedDeals([]);
        // setPendingDeals([]);
        // setCurrentPage(1);
        fetch_bots(searchTerm, currentPage, selectedSort, value);
      }
      updateURLFilters(searchParam, setSearchParam, { keyword: searchTerm });
    }
  };
  const handleSearchClick = () => {
  fetch_bots(searchTerm, currentPage, selectedSort, value);
};

  const onSortChange = (values) => {
    const sort = values?.value;
    fetch_bots(searchTerm, currentPage, sort, value);
    updateURLFilters(searchParam, setSearchParam, { sort_by: sort });
    setnewSelectedSort(sort);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetch_bots(searchTerm, page, selectedSort, value);
    updateURLFilters(searchParam, setSearchParam, { page: page ? page : null });
    // Fetch new data or update content here
  };
  const startLiveBots = async(botid) => {
    console.log("start bot funct called");
    console.log(botid,"botcall")
    try {
      const resp=await axiosInstance.post(`${startBots}/${botid}`,{withCredentials:true})
      if(resp.status===200){
        
        notification.success({
        key: 'no_updates',
        description: "Livebot is started running",
        placement: 'topRight',
      });
         fetch_bots(searchTerm, currentPage, selectedSort, value);
      }
    } catch (error) {
      console.log(error)
    }
  };
  const stopLiveBots = async(botid) => {
    console.log("stop bot funct called");
    try {
      const resp=await axiosInstance.post(`${stopBots}/${botid}`,{withCredentials:true})
      if(resp.status===200){
         notification.warning({
        key: 'no_updates',
        description: "Livebot is stopped",
        placement: 'topRight',
      });
         fetch_bots(searchTerm, currentPage, selectedSort, value);
      }
    } catch (error) {
      console.log(error)
    }
  };
  const handleRepublish = (livebot_id, name, title) => {
    console.log("Republish funct called");
    console.log(livebot_id, name, title);
     Modal.confirm({
    title: `Are you sure you want to republish "${name}"?`,
    content: `This will update the livebot titled "${name}" with the latest bot configuration.`,
    okText: 'Yes, Republish',
    cancelText: 'Cancel',
    centered:true,
    onOk: () => republish_Save(livebot_id),
  });
  };
  const republish_Save = async (live_botid) => {
   try {
     const resp = await axiosInstance.get(`${republishbots}/${live_botid}`,{
     withCredentials: true}
     )
     if(resp.status===200){
      console.log(resp.data)
      if(resp.data.status==="no_change"){
         notification.warning({
        key: 'no_updates',
        description: "Livebot is already up to date.",
        placement: 'topRight',
      });
      }else if(resp.data.status==="updated"){
        notification.success({
        key: 'changes_made',
        description: "Livebot updated with latest bot changes.",
        placement: 'topRight',
      });
      }
     }
   } catch (error) {
    console.log(error)
   }
  };
  const handleRepublishDeleteLiveBots=async(live_bot_id)=>{
    try {
    const resp= await axiosInstance.put(`${deleteBots}/${live_bot_id}`)
    if(resp.status===200){
       fetch_bots(searchTerm, currentPage, selectedSort, value);
    }
    } catch (error) {
      console.log(error)
    }
  }

  console.log(selectedSort,"selectedSort")
  return (
    <>
      <div>
        <div className="row align-items-center justify-content-between">
          <div className=" col-lg-6 col-md-6" onKeyDown={handleKeyDown}>
            <SearchBar
              placeholder="Search your bots by name ..."
              searchTerm={searchTerm}
              handleOnSearch={handleOnSearch}
              handleSearchClick={handleSearchClick}
            />
          </div>

          <div className="col-lg-6 col-md-6 d-flex justify-content-end gap-3 mt-2 mt-md-0">
            <SortMenu
              onSortChange={onSortChange}
              sortOptions={sortOptions}
              selectedSort={selectedSort}
              setSelectedSort={setnewSelectedSort}
            />
            <GlobalButton
              children="Create New Bot"
              size="md"
              className={`${dashboard.backgroundColor} ${dashboard.nohover}`}
              variant="contained"
              onClick={() => setShow(true)}
            />
          </div>
        </div>
        <div className="mt-3">
          <TabBtn value={value} handleTabbtnChange={handleTabbtnChange} />
        </div>
        <div className="row g-3 mt-2">
          {userDetails.map((item, index) => (
            <div className="col-md-4 col-sm-6 col-lg-3" key={index}>
             {value === "all" ? (
  <Cards
    id={item.id}
    name={item.bot_name}
    title={item.bot_desc}
    modifiedDate={item.modifiedDate}
    createdDate={item.createdDate}
    showAction={true}
    showFooter={true}
    handleDelete={handleDelete}
    handlePublish={handlePublish}
    navigateeditIcon={`/bots/createBot?botid=${item.id}`}
    navigatedBotConfig={`/bots/botConfig?bots_type=${value}&botid=${item.id}`}
    tabValue={value}
    stopLiveBots={stopLiveBots}
    startLiveBots={startLiveBots}
    handleRepublish={handleRepublish}
  />
) : value === "livebots" ? (
  <RepublishCard
      id={item.id}
    name={item.bot_name}
    title={item.bot_desc}
    modifiedDate={item.modifiedDate}
    createdDate={item.createdDate}
    showAction={true}
    showFooter={true}
    handleDelete={handleDelete}
    handlePublish={handlePublish}
    navigateeditIcon={`/bots/createBot?botid=${item.id}`}
    // navigatedBotConfig={`/bots/botConfig?bots_type=${value}&botid=${item.bot_idlive}`}
    navigatedBotConfig={`/bots/botConfig?bots_type=${value}&botid=${item.id}`}
    tabValue={value}
    stopLiveBots={stopLiveBots}
    startLiveBots={startLiveBots}
    handleRepublish={handleRepublish}
    bot_id={item.bot_idlive}
    bot_status={item.livebotStatus}
  />
) : null}

            </div>
          ))}
        </div>
      </div>
      {showConfirmModal && (
        <Alerts
          antTitle={BotName.text}
          antContent={BotName.content}
          antOkText={BotName.confirm}
          antCancelText={BotName.cancel}
          setShowConfirmModal={setShowConfirmModal}
          confirmMsgText={BotName.confirmtext}
          id={id}
          action={value==="all"?handleDeleteBot:handleRepublishDeleteLiveBots}
        />
      )}
      <CreateBotModal show={show} setShow={setShow} />
      <PublishModal
        show={showPublicModal}
        setShow={setShowPublicModal}
        publishModalDetails={publishModalDetails}
      />
      {totalCount > BOTSLIMIT && (
        <CommonPagination
          total={totalCount}
          pageSize={BOTSLIMIT}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          showSizeChanger={false}
        />
      )}
    </>
  );
};

export default Dashboard;
